import {
    SESSION_STORAGE_KEY,
} from '../constants';

export function getCacheKey(oshCacheIdentifier) {
    if (oshCacheIdentifier) {
        return `${SESSION_STORAGE_KEY}-${oshCacheIdentifier}`.toLowerCase();
    }

    // Round down to the nearest five minutes.
    const fiveMinutes = 300_000;
    const expiry = Math.floor(Date.now() / fiveMinutes) * fiveMinutes;
    return `${SESSION_STORAGE_KEY}-${expiry}`.toLowerCase();
}

export const clearSessionStorage = (oshCacheIdentifier) => {
    window.sessionStorage.removeItem(getCacheKey(oshCacheIdentifier));
};
